export default __webpack_public_path__ + "static/media/AvAliados-large.16394587.jpg";